import React, { useState, useEffect } from "react";
import {alertsActions, locationActions, useSelector} from "inbooma-api";
import { Biscuit, Notification } from "../../../utils";
import Rbac from "../../../utils/Rbac";
import t from '../../helpers/t';
import {FormatHelper} from '../../../utils';
import { getContentModifications } from '../../../App';
import {_,moment,$} from '../../../../vendor';
import GoogleMap from "../dashboard/components/GoogleMap";
import InboomaSubmenu from "../../components/InboomaSubmenu";
import ContingentsControllerAccessBarMap from "../../../controllers/ContingentsControllerAccessBarMap";
import LocationsSidebar from './components/LocationsSidebar';
import LocationsMobileView from './components/LocationsMobileView';
import ItemView from './components/ItemView';
import {createSubmenuItems} from "../../../utils/Helper";
import ResourcesDialog from './components/ResourcesDialog';

export const rbac = new Rbac({
    _rbac: {
      "admin": {
        write: true,
        delete: true,
        readAll: true,
        editLocation: true,
      },
      "manager": {
        write: true,
        delete: true,
        readAll: true,
        editLocation: true,
      },
      "booking-manager": {
        write: true,
        delete: true,
        readAll: true,
        editLocation: true,
      },
      "manager-location": {
        write: true,
        delete: true,
        readAll: true,
        editLocation: true,
      },
      "garage-staff": {
        write: true,
        delete: false,
        readAll: false,
        editLocation: false,
      },
      "guide": {
        write: false,
        delete: false,
        readAll: false,
        editLocation: false,
      },
      "user": {
        write: false,
        delete: false,
        readAll: false,
        editLocation: false,
      }
    }
  });

export const LocationsPage = props => {

    // mark main menu
    let mainMenu = document.getElementById('inb-main-menu');
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-contingents')) {
        if (mainMenu.querySelector('.active') != null) mainMenu.querySelector('.active').classList.remove('active');
        mainMenu.querySelector('.l-contingents').classList.add('active');
    }
    let language = Biscuit.get('user.lang').replace('-','_');

    // map stuff
    const [mapStatus,setMapStatus] = useState(2);
    const [markers,setMarkers] = useState([]);
    const [mapCenter,setMapCenter] = useState({
        latitude: 51.3386,
        longitude: 12.3766
    });
    const [mapMarker,setMapMarker] = useState({
        url : '',
        width : 0,
        height : 0,
        scaleDown : false,
        ready: false
    });
    const _location = useSelector(state => state.locations_data.location);
    const [locationInfo,setLocationInfo] = useState("");
    const [locationState,setLocationState] = useState('init');                  // init, pending, ready

    // advanced map stuff
    const [mapWidth,setMapWidth] = useState(document.body.scrollWidth);

    // locations stuff
    const [initialized,setInitialized] = useState(false);
    const [locationsPending,setLocationsPending] = useState(false);
    const [locations,setLocations] = useState([]);
    const _locations = useSelector(state => state.locations_data.locations);
    const [resources, setResources] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [locationName, setLocationName] = useState('');


    useEffect(() => {
        if (_locations.success === "") return;
    
        if (_locations.success === true) {
            createMarkerFromLocations(_locations.data);
            setLocations([..._locations.data]);
            setLocationsPending(false);
        } else {
          console.log("Failed to request locations!");
        }
    },[_locations]);

    useEffect(() => {
        if (_location.success === "") return;
    
        if (_location.success === true) {
            for(var i=0;i<markers.length;i++) {
                if (markers[i].id === _location.data.id) {
                    var clone = [...markers];
                    clone[i].info = createMarkerInfoFromLocation(_location.data);
                    setMarkers(clone);
                    return;
                }
            }
            setLocationState('ready');
        } else {
          console.log("Failed to request location!");
        }
    },[_location]);

      /**
         * Return amount of available resources for today
         * 
         * @return {object} see below
         */
    const getNumbersByToday = (contingent) => {
        return getNumbersByDay(moment().hours(0).minutes(0).seconds(0).milliseconds(0),contingent);
    };

    const showResources = (foundResources, locationName) => {
        setResources(foundResources);
        setLocationName(locationName);
        setShowDialog(true);
    }

    const closeDialog = () => {
        setResources([]);
        setLocationName("");
        setShowDialog(false);
    }
    /**
     * Return amount of available resources on a specific day
     * 
     * @param {String|Moment} day
     * @return {object} w/ attributes id, contingent_id, number, valid_from
     */
    const getNumbersByDay = (day,contingent) => {

        if (typeof day === 'string') {
            day = moment(day);
        }

        let result;

        _.each(contingent.contingent_numbers, function(numberObj, __) {

            const valid_from = moment(numberObj.valid_from);

            if (valid_from.isSameOrBefore(day)) {
                if (typeof result !== 'undefined') {
                    // Compare with previous valid_from
                    if (moment(result.valid_from).isAfter(valid_from)) {
                        return;
                    }
                }

                result = numberObj;
            }
        });

        return result;
    };

    const createMarkerInfoFromLocation = (data) => {

        const user_role = Biscuit.get('user.role');
        var tpl =
            '<div class="locationItemPopup">' +
                '<h4>' + data.name + '</h4>' +
                '<p class="description">' + (data.description == null ? '' : data.description) + '</p>' +
                '<ul class="inb-vert-list">';

        if (data.contingents.length > 0) {
            tpl += '<span class="inb-list-title">' + t("contingents",null,"capital") + '</span>';
                    _.each(
                        _.sortBy(data.contingents, function(model) {return model.name}),
                            function(cont, key) {
                                var number_active = getNumbersByToday(cont);
                                var result = '<li><a href="/contingents/' + cont.id + '/edit">';
                                result += (cont.name + ' ' + FormatHelper.formatContingentTags(cont.tags));
                                if (number_active) result += (' (' + number_active.number + ' ' + t("vehicles_active") + ')');
                                result += '</a></li>';
                                tpl += result;
                            });
        } else {
            tpl += '<li>' + t("no_contingents_yet") + '</li>';
        }
        tpl += '</ul>';

        if (user_role === 'admin' || user_role === 'manager' || user_role === 'manager_location') {
            tpl += 
            '<hr />' +
            '<a ' +
                'href="/locations/' + data.id + '"' +
                'class="location__edit">' +
                t("edit",null,"capital") +
            '</a>' + 
            '|' + 
            '<a ' +
                'href="/locations/' + data.id + '?action=delete" ' +
                'class="location__remove">' +
                t("remove",null,"capital") +
            '</a>' +
            '|'; 
        }

        if (user_role === 'admin' || user_role === 'manager' || user_role === 'manager_location') {
            tpl +=
            '<a ' +
                'href="/check_in_periods?location_id=' + data.id + '" ' +
                'title="' + t('edit_${a}',{a:t('opening_times')}) + '" ' +
                'class="location__opening_times">' +
                t("opening_times",null,"capital") +
            '</a>';
        }
        tpl += '</div>';

        return tpl;
    };

    const createMarkerFromLocations = (locations) => {

        const clientProduct = Biscuit.get('client.product');

        let markerImage = Biscuit.get('client.marker');

        if (typeof markerImage === 'undefined' || markerImage === '' || markerImage === null) {
            if (typeof clientProduct !== 'undefined' && clientProduct === 'inbooma.net Booking Software') {
                // Default client
                markerImage = 'assets/img/default-map-marker.png';
            } else {
                // Bikesharing client
                markerImage = 'assets/img/default-map-marker-bikesharing.png';
            }
        }
        
        // This should only be a temporary solution
        // Actual "problem": On initial page load, LocationsView becomes called too early so client
        // logo & marker is not set yet. Solution: Defer rendering, e.g. via dedicated Radio-event called from App.js
        // or (too be developed) via InboomaBaseView (e.g. this.dependencies = { models: { type: 'client', id: Biscuit.get('user.client_id') } })
        if (Number(Biscuit.get('user.client_id')) === 7) {
            markerImage = 'https://s3.eu-central-1.amazonaws.com/inbooma/images/rab_mapmarker.png';
        }

        if (Number(Biscuit.get('user.client_id')) === 11) {
            markerImage = 'assets/img/default-map-marker-bikesharing.png';
        }

        let _markers = [];
        for (var i=0;i<locations.length;i++) {
            _markers.push({
                id: locations[i].id,
                longitude: locations[i].longitude,
                latitude: locations[i].latitude,
                title: locations[i].name,
                draggable: false,
                imageUrl: locations[i].location_marker !== null && locations[i].location_marker !== ''?locations[i].location_marker:markerImage,
                imageSize: {
                    width: mapMarker.width === 0 ? 80 : mapMarker.width,
                    height: mapMarker.height === 0  ? 100 : mapMarker.height
                },
                imageDownScale: mapMarker.scaleDown
            });
        }
        setMarkers(_markers);
    };

    const getMarkerInfo = (index) => {

        if (markers.length > index) {
            for (var i=0;i<locations.length;i++) {
                if (locations[i].id === markers[index].id) {
                    props.dispatch(locationActions.getLocation({
                        token: Biscuit.get('token'),
                        id : markers[index].id,
                        parameters: {
                            headers: {
                                'Accept-Language': language,
                                'Content-Language': language
                            }
                        }
                    }));
                    return null;
                }
            }
        }
        return null;
    };

    // remove marker info again (on close)
    const removeMarkerInfo = (index) => {

        if (markers.length > index && typeof markers[index].info !== 'undefined' && markers[index].info != null) {
            var clone = [...markers];
            clone[index].info = null;
            setMarkers(clone);
        }
    };

    // called after changing location filter
    const onFilterChanged = (filter) => {
/*
        props.dispatch(facilityActions.getFacilities({
          token: Biscuit.get('token'),
          filter: filter
        }));*/
    };

    const showNotification = (msgType, itemId) => {

        if (msgType === 'success') {
          new Notification({
            message : t('saved_${a}',{a:t('location')},'capital')+' #'+ itemId,
            duration : 5000,
            type : 'success',
            closeable : true,
            icon : 'fi fi-check'
          });
        } else if (msgType === 'warning') {
          new Notification({
            message : t('request_error',null,'capital'),
            duration : 5000,
            type : 'warning',
            closeable : true,
            icon : 'fi fi-x'
          });
        }
      };

    const getMapContainerHeight = (ret = '100') => {

        const accessbar = document.getElementById('inb-c-main-access-bar');
        if (accessbar) {
            ret = 'calc('+ret+'% - ' + (accessbar.scrollHeight + 2) + 'px)';
            return ret+'%';
        } else {
            return ret+'%';
        }
    };

    // observer is necessary to force re-render of map container with matching dimensions
    const onResize = () => {

        setMapWidth(document.body.scrollWidth);
    };

    const onCloseLocation = () => {

        console.log("closed");
    };

    const preselectLocation = () => {

        if (props.status.action !== 'edit' || props.status.location_id === null) return;

        if (_location && _location.id === props.status.location_id) return;

        if (locationState === 'init') {
            props.dispatch(locationActions.getLocation({
                token: Biscuit.get('token'),
                id: props.status.location_id,
                parameters: {
                    headers: {
                        "Accept-Language": (Biscuit.get('user.lang').replace('-', '_'))
                    }
                }
            }));
            setLocationState('pending');
        }
    };

    const initialize = () => {

        if (initialized === true) return;

        // check if content modifications have been loaded
        if (!getContentModifications().isReady) {

            setTimeout(() => {
                initialize();                
            },300);
            return;
        }
        if (locationsPending === false) {
            props.dispatch(locationActions.getLocations({
                token: Biscuit.get('token'),
                filter: {
                    findForSelect: true,
                    find: 'short'
                },
                parameters: {
                    headers: {
                        "Accept-Language": (Biscuit.get('user.lang').replace('-', '_'))
                    }
                }
            }));
            setLocationsPending(true);
        }

        window.addEventListener('resize', onResize);
        setInitialized(true);
    };

    initialize();

    preselectLocation();

    const submenuItems = createSubmenuItems('locations');

    return (
        <div id="inb-c-main" style={{width:'100%'}}>
            <LocationsSidebar
                locations={locations}
                setSelectedFilter={onFilterChanged}
                locationSelectHandle={getMarkerInfo}
                dispatch={props.dispatch}
                showResources={showResources}
            />
            {props.createAccessBar &&
                <InboomaSubmenu
                tabs={submenuItems}
                smallOnlyTitle={t('locations',null,'capital')}
                extraStyle={{display:"flex"}}
                />
            }
            <div id="inb-c-locations-map-container" className="full hide-for-small-only" style={{height:getMapContainerHeight(),marginLeft: "5.3%"}}>
                <GoogleMap
                    hasOverlay={false}
                    hasHeader={false}
                    hasFoooter={false}
                    hasFixedPosition={true}
                    redrawOnResize={false}
                    containerSize={{width:'100%',height:'100%'}}
                    containerMargin={{left: '0px',top:'0px'}}
                    containerColor={"white"}
                    markers={markers}
                    zoomLevel={9}
                    defaultCenter={mapCenter}
                    //center={mapCenter}    // if not set: center is set by markers bounding
                    status={mapStatus}
                    onClickMarkerHandler={getMarkerInfo}
                    removeMarkerInfo={removeMarkerInfo}/>
            </div>
            <div id="inb-c-locations-map-container" className="full show-for-small-only" style={{}}>
                {/* <GoogleMap
                    hasOverlay={false}
                    hasHeader={false}
                    hasFoooter={false}
                    hasFixedPosition={true}
                    redrawOnResize={false}
                    containerSize={{width:'10%',height:'10%'}}
                    containerMargin={{left: '10px',top:'10px'}}
                    containerColor={"white"}
                    markers={markers}
                    zoomLevel={9}
                    defaultCenter={mapCenter}
                    //center={mapCenter}    // if not set: center is set by markers bounding
                    status={mapStatus}
                    onClickMarkerHandler={getMarkerInfo}
                    removeMarkerInfo={removeMarkerInfo}/> */}
                    <LocationsMobileView
                        locations={locations}
                setSelectedFilter={onFilterChanged}
                locationSelectHandle={getMarkerInfo}
                    />
                
                
            </div>
            {(props.status.action == 'add' || (props.status.action == 'edit' && locationState == 'ready')) && rbac.hasPermission('editLocation') &&
                <ItemView
                    onClose={onCloseLocation}
                    dispatch={props.dispatch}
                    location={props.status.action == 'add' ? {} : _location.data}
                    action={props.status.action}
                    showNotification={showNotification}/>
            }
            {showDialog &&
                 <ResourcesDialog
                     resources={resources}
                     locationName={locationName}
                     handleCloseDialog={closeDialog}
                     dispatch={props.dispatch}
                     showNotification={showNotification}
                />
            }
        </div>
    );
};